import { Controller } from "@hotwired/stimulus"

// inline 완료 입력 폼 토글 — in_progress 회차 완료 입력 (completed_at + completion_detail).
// 사용법: inline-edit 와 동일 패턴.
//   <div data-controller="inline-complete">
//     <button data-action="click->inline-complete#toggle">완료</button>
//     <div data-inline-complete-target="form" class="hidden">...폼...</div>
//   </div>
export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    if (event) event.preventDefault()
    this.formTarget.classList.toggle("hidden")
    if (!this.formTarget.classList.contains("hidden")) {
      this.formTarget.scrollIntoView({ behavior: "smooth", block: "start" })
      const first = this.formTarget.querySelector("input, select, textarea")
      if (first) first.focus()
    }
  }

  hide() {
    this.formTarget.classList.add("hidden")
  }
}
